import React from "react";
import styles from "./CarPopup.css";
import SpeedIcon from "./images/speed.svg";
import { LastUpdateTime, PowerStatus } from "..";
import { isValidLicensePlate } from "../../isValidLicensePlate";

interface Props {
  licensePlate: string | null;
  ignitionOn: boolean;
  speed: number;
  brand: string | null;
  model: string | null;
  address: string | null;
  driverName: string | null;
  lastUpdatedTime: number | null;
  isRealTimeUpdated: boolean;
}

export const CarPopup = ({
  licensePlate,
  ignitionOn,
  speed,
  brand,
  model,
  address,
  driverName,
  lastUpdatedTime,
  isRealTimeUpdated
}: Props) => (
  <div className={styles.container}>
    <div className={styles.containerTitle}>
      {getTitle(licensePlate, speed, ignitionOn)}
    </div>
    <div className={styles.wrapperInfo}>
      <div className={styles.brandModelDriverName}>
        {brand} {model} {!brand && !model && "Modelo não cadastrado"} -{" "}
        {driverName || "Motorista não associado"}
      </div>
      <div className={styles.address}>
        {address || "Não é possível exibir o endereço neste momento."}
      </div>
      {!isRealTimeUpdated && lastUpdatedTime && (
        <LastUpdateTime
          className={styles.lastUpdate}
          lastUpdatedTime={lastUpdatedTime}
        />
      )}
    </div>
  </div>
);

const getTitle = (
  licensePlate: string | null,
  speed: number,
  ignitionOn: boolean
) => {
  if (ignitionOn) {
    return (
      <>
        <LincensePlate licensePlate={licensePlate} />
        <div className={styles.divider} />
        <PowerStatus className={styles.info} ignitionOn={true} />
        <div className={styles.divider} />
        <div className={styles.speed}>
          <SpeedIcon /> {Math.round(speed)} km/h
        </div>
      </>
    );
  }

  return (
    <div className={styles.containerDisable}>
      <div>
        <LincensePlate licensePlate={licensePlate} />
      </div>
      <PowerStatus className={styles.info} ignitionOn={false} />
    </div>
  );
};

interface LincensePlateProps {
  licensePlate: string | null;
}

const LincensePlate = ({ licensePlate }: LincensePlateProps) => {
  if (licensePlate && !isValidLicensePlate(licensePlate)) {
    return null;
  }

  return (
    <div className={styles.licensePlate}>{licensePlate || "Sem placa"}</div>
  );
};
